import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConstantsModule } from './constants.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class TableConstantsModule { 
  constructor(private constants:ConstantsModule){}
  
  SORT_DIRECTION = {
    DESC : 'desc',
    ASC : 'asc',
    NONE : ''
  };

  GEC_TABLE_COLUMNS_MAP = {
    "ALL_LEVEL" :{
      'columns' : {'name' : {'displayAs':'Location Name','clickable':true},'rainfall' : {'displayAs':'Rainfall (mm)', 'unit': 'decimalthree'},'recharge' : {'displayAs':'Ground Water Recharge (ham)', 'unit': 'decimalthree'},'draft' : {'displayAs':'Ground Water Extraction(ham)', 'unit': 'decimalthree'}},
      'defaultSortOn' : 'name',
      'sortDirection' : this.SORT_DIRECTION.ASC
    },
    "LAST_LEVEL" :{
      'columns' : {'name' : {'displayAs':'Location Name','clickable':true},'rainfall' : {'displayAs':'Rainfall (mm)', 'unit': 'decimalthree'},'recharge' : {'displayAs':'Ground Water Recharge (ham)', 'unit': 'decimalthree'},'draft' : {'displayAs':'Ground Water Extraction (ham)', 'unit': 'decimalthree'},'category' : {'displayAs':'Category', 'unit': 'decimalthree'},'stageofextraction (%)' : {'displayAs':'Stage of Extraction', 'unit': 'decimalthree'}},
      'defaultSortOn' : 'name',
      'sortDirection' : this.SORT_DIRECTION.ASC
    },
  };

  APPROVAL_TABLE_HEADERS = {
    "GEC_CENTRAL_ADMIN":{
      "approval":[{"key":"Indicator","value":"Indicator"},{"key":"Value","value":"Value"}],
      "history":[{"key":"Indicator","value":"indicator"},{"key":"Value","value":"value"},{"key":"date","value":"Submission Date"}]
    }
  };
  // WEIGHTAGES_TABLE_HEADER = {
  //   "GEC_CENTRAL_ADMIN":{
  //     "approval":[{"key":"Indicator","value":"indicator"},{"key":"Value","value":"value"}],
  //     "history":[{"key":"Indicator","value":"indicator"},{"key":"Value","value":"value"},{"key":"date","value":"Submission Date"}]
  //   }
  // }
 

}
